import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  menus
} from "data/actions";
import { TOGGLE_RIGHT } from "data/menus/types";


class RightDrawer extends Component {


  render() {
  

    return (
      <aside
        id="rightdrawer"
        className={
          this.props.showRight
            ? "right right_open "
            : "right "
        }
      >
        <a className="close" onClick={this.props.actions.toggleRight}>
          ×
        </a>
        <div className="right__sticky">
          <div className="right__scroll">
            {this.props.children}
          </div>
        </div>
      </aside>
    );
  }
}

function mapStateToProps(state) {
return {
    showRight: state.menus && state.menus.open === TOGGLE_RIGHT
  };
  
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...menus },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(RightDrawer);



// WEBPACK FOOTER //
// ./src/components/Page/RightDrawer.jsx